import { jsx as _jsx } from "react/jsx-runtime";
import OverflowManager from '../OverflowManager';
import { Metadata } from './styles';
var Info = function (props) {
    var children = props.children;
    return (_jsx("div", { style: { gridArea: 'info' }, children: _jsx(Metadata, { children: _jsx(OverflowManager, { children: children }) }) }));
};
export default Info;
